// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";

var bronzeHeroBadge = RnrAssetManager.getImage("milestones/bronze_hero.svg");

var starBadge = RnrAssetManager.getImage("milestones/star.svg");

var bronzeSuperStarBadge = RnrAssetManager.getImage("milestones/bronze_super_star.svg");

var silverHeroBadge = RnrAssetManager.getImage("milestones/silver_hero.svg");

var silverSuperStarBadge = RnrAssetManager.getImage("milestones/silver_super_star.svg");

var platinumHeroBadge = RnrAssetManager.getImage("milestones/platinum_hero.svg");

var platinumSuperStarBadge = RnrAssetManager.getImage("milestones/platinum_super_star.svg");

var goldHeroBadge = RnrAssetManager.getImage("milestones/gold_hero.svg");

var goldSuperStarBadge = RnrAssetManager.getImage("milestones/gold_super_star.svg");

var diamondHeroBadge = RnrAssetManager.getImage("milestones/diamond_hero.svg");

var diamondSuperStarBadge = RnrAssetManager.getImage("milestones/diamond_super_star.svg");

var suproSuperStarBadge = RnrAssetManager.getImage("milestones/supro_super_star.svg");

var lockBadge = RnrAssetManager.getImage("milestones/locked.svg");

function getBadge(milestone) {
  switch (milestone) {
    case /* Star */0 :
        return starBadge;
    case /* BronzeHero */1 :
        return bronzeHeroBadge;
    case /* BronzeSuperStar */2 :
        return bronzeSuperStarBadge;
    case /* SilverHero */3 :
        return silverHeroBadge;
    case /* SilverSuperStar */4 :
        return silverSuperStarBadge;
    case /* PlatinumHero */5 :
        return platinumHeroBadge;
    case /* PlatinumSuperStar */6 :
        return platinumSuperStarBadge;
    case /* GoldHero */7 :
        return goldHeroBadge;
    case /* GoldSuperStar */8 :
        return goldSuperStarBadge;
    case /* DiamondHero */9 :
        return diamondHeroBadge;
    case /* DiamondSuperStar */10 :
        return diamondSuperStarBadge;
    case /* PorterHero */11 :
    case /* SuproSuperStar */12 :
        return suproSuperStarBadge;
    
  }
}

export {
  bronzeHeroBadge ,
  starBadge ,
  bronzeSuperStarBadge ,
  silverHeroBadge ,
  silverSuperStarBadge ,
  platinumHeroBadge ,
  platinumSuperStarBadge ,
  goldHeroBadge ,
  goldSuperStarBadge ,
  diamondHeroBadge ,
  diamondSuperStarBadge ,
  suproSuperStarBadge ,
  lockBadge ,
  getBadge ,
  
}
/* bronzeHeroBadge Not a pure module */
